module.exports = __webpack_public_path__ + "media/images/medal-59aabf13ce0d77982e8c831d72e38294.svg";